import $ from 'jquery'

export function init() {
  if (window.disableAutoTargetLinks) return
  $('a, area')
    .filter(function () {
      const href = $(this).attr('href')
      return (
        href &&
        !this.target &&
        ((href.indexOf(window.location.hostname) == -1 && href.match(/^https?/i)) || href.match(/\.pdf$/i))
      )
    })
    .attr('target', '_blank')
}
